import { SearchIcon } from "assets";
import styles from "./styles.module.scss";

interface SearchProps {
  className?: string;
  value: string;
  placeholder: string;
  handleChange: (val: string) => void;
  transparent?: boolean;
}

const Search: React.FC<SearchProps> = ({
  className,
  handleChange,
  value,
  placeholder,
  transparent
}) => {
  return (
    <div
      className={`${styles.searchContainer} ${className} ${transparent ? styles.transparent : ""}`}
    >
      <SearchIcon />
      <input
        onChange={(e) => handleChange(e.target.value)}
        value={value}
        placeholder={placeholder}
        type="search"
      />
    </div>
  );
};

export { Search };
